<template>
    <InputLayout :v="v" :label="label">
        <div class="input-group" :class="{ 'is-invalid': v && v.$error }">

        <div v-if="prependIcon" class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1"><i class="bi" :class="prependIcon"></i></span>
        </div>
        <select
            class="form-select" 
            :id="v.$path" 
            :class="{ 'is-invalid': v && v.$error }" 
            :value="modelValue" 
            @input="$emit('update:modelValue', $event.target.value)"  
        >
            <option v-if="!removeEmptyOption" :disabled="disableFirstOption"></option>
            <option v-for="option of options" v-bind:key="option.id" :value="option.id" :disabled="option.enabled !== undefined && option.enabled != true">{{option.label}}</option>
        </select>
    </div>
    </InputLayout>
</template>

<script>
    import InputLayout from '@/components/InputLayout.vue';

    export default {
        props: {
            label: {
                required: true
            },
            v: {
                required: true,
            },
            modelValue: {
                required: true,
            },
            options: {
                required: true,
            },
            removeEmptyOption: {
              default: false
            },
            prependIcon: {
              default: false
            },
            disableFirstOption: {
              default: false
            },
        },
        components: {            
            InputLayout,
        },
        emits: ['update:modelValue'],
    }
</script>
